export default function () {
  return {
    title: "Titulo",
    logo: "",
    namePainelDelete: {}
  };
}